import { api } from "../../utils";
import * as simulators from "./simulators-routes";
import * as filePicker from "./file-picker-routes";

export * from "./cesu-routes";
export * from "./chat-route";
export * from "./job-routes";
export * from "./location-routes";
export * from "./new-relation-routes";
export * from "./sign-routes";

export const get = ({ route, params }) => api.get(route, { ...params });
export { simulators, filePicker };
